export interface PriceBand {
  from: number;
  /** Null for the open-ended band above the last boundary. */
  to: number | null;
}

/**
 * Builds the list of portal price bands intersecting the [low, high] price range of
 * the dataset. Boundaries follow the portal's price-filter steps; the range below the
 * first step and the open range above the last one are bands too, so every car falls
 * into exactly one band. A price sitting exactly on a boundary belongs to the band
 * starting there (matching a "from 15 000" portal filter).
 */
export function getPriceBands(boundaries: number[], low: number, high: number): PriceBand[] {
  const allBands: PriceBand[] = [
    {from: 0, to: boundaries[0] ?? null},
    ...boundaries.map((from, index) => ({from, to: boundaries[index + 1] ?? null})),
  ];

  return allBands.filter((band) => band.from <= high && (band.to === null || band.to > low));
}

/** Index of the band a price falls into; -1 when outside every provided band. */
export function getPriceBandIndex(bands: PriceBand[], price: number): number {
  return bands.findIndex((band) => price >= band.from && (band.to === null || price < band.to));
}
